<div class="container mt-4">

  <button (click)="generateExcel()" class="btn btn-secondary mb-2"> Export Excel</button>
  <!-- <button (click)="downloadPDFWithjsPDF()" class="btn btn-secondary mb-2"> Export pdf</button> -->
  <button (click)="downloadPDF()" class="btn btn-secondary mb-2"> Export pdf</button>

  <table class="table" id="datatable" #pdfPage *ngIf="false">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Seq.</th>
        <th scope="col">Year</th>
        <th scope="col">Month</th>
        <th scope="col">Facebook</th>
        <th scope="col">Reddit</th>
        <th scope="col">LinkedIn</th>
        <th scope="col">Instagram</th>
        <th scope="col">عربي</th>
        <th scope="col">Image</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let p of data; let i = index">
        <th scope="row">{{i+1}}</th>
        <th scope="row">{{p[0]}}</th>
        <td>{{p[1]}}</td>
        <td>{{p[2]}}</td>
        <td>{{p[3]}}</td>
        <td>{{p[4]}}</td>
        <td>{{p[5]}}</td>
        <td>عربي</td>
        <td>
          <img src="https://www.gravatar.com/avatar/d50c83cc0c6523b4d3f6085295c953e0"
            onerror="this.src ='assets/images/stud-image.png';" alt="Photo" class="img-fluid" width="70" style="  border-radius: 115px;
            margin-bottom: 3px;
            margin-top: 3px;
            max-height: 200px;" (load)="getBase64($event, i)" crossOrigin='Anonymous'>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- <img src="assets/images/stud-image.png" width="100" height="100" #myImage /> -->
  <br />
  <br />
  <br />
  <!-- Second table -->
  <table id="example" class="display" style="width:100%">
    <thead>
      <tr>
        <th>sequence</th>
        <th>#</th>
        <th>Name</th>
        <th>Position</th>
        <th>Office</th>
        <th>Start date</th>
        <th>Salary</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>2</td>
        <td>2</td>
        <td>Tiger Nixon</td>
        <td>System Architect</td>
        <td>Edinburgh</td>
        <td>2011/04/25</td>
        <td>$320,800</td>
      </tr>
      <tr>
        <td>22</td>
        <td>22</td>
        <td>Garrett Winters</td>
        <td>Accountant</td>
        <td>Tokyo</td>
        <td>2011/07/25</td>
        <td>$170,750</td>
      </tr>
      <tr>
        <td>6</td>
        <td>6</td>
        <td>Ashton Cox</td>
        <td>Junior Technical Author</td>
        <td>San Francisco</td>
        <td>2009/01/12</td>
        <td>$86,000</td>
      </tr>
      <tr>
        <td>41</td>
        <td>41</td>
        <td>Cedric Kelly</td>
        <td>Senior Javascript Developer</td>
        <td>Edinburgh</td>
        <td>2012/03/29</td>
        <td>$433,060</td>
      </tr>
      <tr>
        <td>55</td>
        <td>55</td>
        <td>Airi Satou</td>
        <td>Accountant</td>
        <td>Tokyo</td>
        <td>2008/11/28</td>
        <td>$162,700</td>
      </tr>
      <tr>
        <td>21</td>
        <td>21</td>
        <td>Brielle Williamson</td>
        <td>Integration Specialist</td>
        <td>New York</td>
        <td>2012/12/02</td>
        <td>$372,000</td>
      </tr>
      <tr>
        <td>46</td>
        <td>46</td>
        <td>Herrod Chandler</td>
        <td>Sales Assistant</td>
        <td>San Francisco</td>
        <td>2012/08/06</td>
        <td>$137,500</td>
      </tr>
      <tr>
        <td>50</td>
        <td>50</td>
        <td>Rhona Davidson</td>
        <td>Integration Specialist</td>
        <td>Tokyo</td>
        <td>2010/10/14</td>
        <td>$327,900</td>
      </tr>
      <tr>
        <td>26</td>
        <td>26</td>
        <td>Colleen Hurst</td>
        <td>Javascript Developer</td>
        <td>San Francisco</td>
        <td>2009/09/15</td>
        <td>$205,500</td>
      </tr>
      <tr>
        <td>18</td>
        <td>18</td>
        <td>Sonya Frost</td>
        <td>Software Engineer</td>
        <td>Edinburgh</td>
        <td>2008/12/13</td>
        <td>$103,600</td>
      </tr>
      <tr>
        <td>13</td>
        <td>13</td>
        <td>Jena Gaines</td>
        <td>Office Manager</td>
        <td>London</td>
        <td>2008/12/19</td>
        <td>$90,560</td>
      </tr>
      <tr>
        <td>23</td>
        <td>23</td>
        <td>Quinn Flynn</td>
        <td>Support Lead</td>
        <td>Edinburgh</td>
        <td>2013/03/03</td>
        <td>$342,000</td>
      </tr>
      <tr>
        <td>14</td>
        <td>14</td>
        <td>Charde Marshall</td>
        <td>Regional Director</td>
        <td>San Francisco</td>
        <td>2008/10/16</td>
        <td>$470,600</td>
      </tr>
      <tr>
        <td>12</td>
        <td>12</td>
        <td>Haley Kennedy</td>
        <td>Senior Marketing Designer</td>
        <td>London</td>
        <td>2012/12/18</td>
        <td>$313,500</td>
      </tr>
      <tr>
        <td>54</td>
        <td>54</td>
        <td>Tatyana Fitzpatrick</td>
        <td>Regional Director</td>
        <td>London</td>
        <td>2010/03/17</td>
        <td>$385,750</td>
      </tr>
      <tr>
        <td>37</td>
        <td>37</td>
        <td>Michael Silva</td>
        <td>Marketing Designer</td>
        <td>London</td>
        <td>2012/11/27</td>
        <td>$198,500</td>
      </tr>
      <tr>
        <td>32</td>
        <td>32</td>
        <td>Paul Byrd</td>
        <td>Chief Financial Officer (CFO)</td>
        <td>New York</td>
        <td>2010/06/09</td>
        <td>$725,000</td>
      </tr>
      <tr>
        <td>35</td>
        <td>35</td>
        <td>Gloria Little</td>
        <td>Systems Administrator</td>
        <td>New York</td>
        <td>2009/04/10</td>
        <td>$237,500</td>
      </tr>
      <tr>
        <td>48</td>
        <td>48</td>
        <td>Bradley Greer</td>
        <td>Software Engineer</td>
        <td>London</td>
        <td>2012/10/13</td>
        <td>$132,000</td>
      </tr>
      <tr>
        <td>45</td>
        <td>45</td>
        <td>Dai Rios</td>
        <td>Personnel Lead</td>
        <td>Edinburgh</td>
        <td>2012/09/26</td>
        <td>$217,500</td>
      </tr>
      <tr>
        <td>17</td>
        <td>17</td>
        <td>Jenette Caldwell</td>
        <td>Development Lead</td>
        <td>New York</td>
        <td>2011/09/03</td>
        <td>$345,000</td>
      </tr>
      <tr>
        <td>57</td>
        <td>57</td>
        <td>Yuri Berry</td>
        <td>Chief Marketing Officer (CMO)</td>
        <td>New York</td>
        <td>2009/06/25</td>
        <td>$675,000</td>
      </tr>
      <tr>
        <td>29</td>
        <td>29</td>
        <td>Caesar Vance</td>
        <td>Pre-Sales Support</td>
        <td>New York</td>
        <td>2011/12/12</td>
        <td>$106,450</td>
      </tr>
      <tr>
        <td>56</td>
        <td>56</td>
        <td>Doris Wilder</td>
        <td>Sales Assistant</td>
        <td>Sydney</td>
        <td>2010/09/20</td>
        <td>$85,600</td>
      </tr>
      <tr>
        <td>36</td>
        <td>36</td>
        <td>Angelica Ramos</td>
        <td>Chief Executive Officer (CEO)</td>
        <td>London</td>
        <td>2009/10/09</td>
        <td>$1,200,000</td>
      </tr>
      <tr>
        <td>5</td>
        <td>5</td>
        <td>Gavin Joyce</td>
        <td>Developer</td>
        <td>Edinburgh</td>
        <td>2010/12/22</td>
        <td>$92,575</td>
      </tr>
      <tr>
        <td>51</td>
        <td>51</td>
        <td>Jennifer Chang</td>
        <td>Regional Director</td>
        <td>Singapore</td>
        <td>2010/11/14</td>
        <td>$357,650</td>
      </tr>
      <tr>
        <td>20</td>
        <td>20</td>
        <td>Brenden Wagner</td>
        <td>Software Engineer</td>
        <td>San Francisco</td>
        <td>2011/06/07</td>
        <td>$206,850</td>
      </tr>
      <tr>
        <td>7</td>
        <td>7</td>
        <td>Fiona Green</td>
        <td>Chief Operating Officer (COO)</td>
        <td>San Francisco</td>
        <td>2010/03/11</td>
        <td>$850,000</td>
      </tr>
      <tr>
        <td>1</td>
        <td>1</td>
        <td>Shou Itou</td>
        <td>Regional Marketing</td>
        <td>Tokyo</td>
        <td>2011/08/14</td>
        <td>$163,000</td>
      </tr>
      <tr>
        <td>39</td>
        <td>39</td>
        <td>Michelle House</td>
        <td>Integration Specialist</td>
        <td>Sydney</td>
        <td>2011/06/02</td>
        <td>$95,400</td>
      </tr>
      <tr>
        <td>40</td>
        <td>40</td>
        <td>Suki Burks</td>
        <td>Developer</td>
        <td>London</td>
        <td>2009/10/22</td>
        <td>$114,500</td>
      </tr>
      <tr>
        <td>47</td>
        <td>47</td>
        <td>Prescott Bartlett</td>
        <td>Technical Author</td>
        <td>London</td>
        <td>2011/05/07</td>
        <td>$145,000</td>
      </tr>
      <tr>
        <td>52</td>
        <td>52</td>
        <td>Gavin Cortez</td>
        <td>Team Leader</td>
        <td>San Francisco</td>
        <td>2008/10/26</td>
        <td>$235,500</td>
      </tr>
      <tr>
        <td>8</td>
        <td>8</td>
        <td>Martena Mccray</td>
        <td>Post-Sales support</td>
        <td>Edinburgh</td>
        <td>2011/03/09</td>
        <td>$324,050</td>
      </tr>
      <tr>
        <td>24</td>
        <td>24</td>
        <td>Unity Butler</td>
        <td>Marketing Designer</td>
        <td>San Francisco</td>
        <td>2009/12/09</td>
        <td>$85,675</td>
      </tr>
      <tr>
        <td>38</td>
        <td>38</td>
        <td>Howard Hatfield</td>
        <td>Office Manager</td>
        <td>San Francisco</td>
        <td>2008/12/16</td>
        <td>$164,500</td>
      </tr>
      <tr>
        <td>53</td>
        <td>53</td>
        <td>Hope Fuentes</td>
        <td>Secretary</td>
        <td>San Francisco</td>
        <td>2010/02/12</td>
        <td>$109,850</td>
      </tr>
      <tr>
        <td>30</td>
        <td>30</td>
        <td>Vivian Harrell</td>
        <td>Financial Controller</td>
        <td>San Francisco</td>
        <td>2009/02/14</td>
        <td>$452,500</td>
      </tr>
      <tr>
        <td>28</td>
        <td>28</td>
        <td>Timothy Mooney</td>
        <td>Office Manager</td>
        <td>London</td>
        <td>2008/12/11</td>
        <td>$136,200</td>
      </tr>
      <tr>
        <td>34</td>
        <td>34</td>
        <td>Jackson Bradshaw</td>
        <td>Director</td>
        <td>New York</td>
        <td>2008/09/26</td>
        <td>$645,750</td>
      </tr>
      <tr>
        <td>4</td>
        <td>4</td>
        <td>Olivia Liang</td>
        <td>Support Engineer</td>
        <td>Singapore</td>
        <td>2011/02/03</td>
        <td>$234,500</td>
      </tr>
      <tr>
        <td>3</td>
        <td>3</td>
        <td>Bruno Nash</td>
        <td>Software Engineer</td>
        <td>London</td>
        <td>2011/05/03</td>
        <td>$163,500</td>
      </tr>
      <tr>
        <td>31</td>
        <td>31</td>
        <td>Sakura Yamamoto</td>
        <td>Support Engineer</td>
        <td>Tokyo</td>
        <td>2009/08/19</td>
        <td>$139,575</td>
      </tr>
      <tr>
        <td>11</td>
        <td>11</td>
        <td>Thor Walton</td>
        <td>Developer</td>
        <td>New York</td>
        <td>2013/08/11</td>
        <td>$98,540</td>
      </tr>
      <tr>
        <td>10</td>
        <td>10</td>
        <td>Finn Camacho</td>
        <td>Support Engineer</td>
        <td>San Francisco</td>
        <td>2009/07/07</td>
        <td>$87,500</td>
      </tr>
      <tr>
        <td>44</td>
        <td>44</td>
        <td>Serge Baldwin</td>
        <td>Data Coordinator</td>
        <td>Singapore</td>
        <td>2012/04/09</td>
        <td>$138,575</td>
      </tr>
      <tr>
        <td>42</td>
        <td>42</td>
        <td>Zenaida Frank</td>
        <td>Software Engineer</td>
        <td>New York</td>
        <td>2010/01/04</td>
        <td>$125,250</td>
      </tr>
      <tr>
        <td>27</td>
        <td>27</td>
        <td>Zorita Serrano</td>
        <td>Software Engineer</td>
        <td>San Francisco</td>
        <td>2012/06/01</td>
        <td>$115,000</td>
      </tr>
      <tr>
        <td>49</td>
        <td>49</td>
        <td>Jennifer Acosta</td>
        <td>Junior Javascript Developer</td>
        <td>Edinburgh</td>
        <td>2013/02/01</td>
        <td>$75,650</td>
      </tr>
      <tr>
        <td>15</td>
        <td>15</td>
        <td>Cara Stevens</td>
        <td>Sales Assistant</td>
        <td>New York</td>
        <td>2011/12/06</td>
        <td>$145,600</td>
      </tr>
      <tr>
        <td>9</td>
        <td>9</td>
        <td>Hermione Butler</td>
        <td>Regional Director</td>
        <td>London</td>
        <td>2011/03/21</td>
        <td>$356,250</td>
      </tr>
      <tr>
        <td>25</td>
        <td>25</td>
        <td>Lael Greer</td>
        <td>Systems Administrator</td>
        <td>London</td>
        <td>2009/02/27</td>
        <td>$103,500</td>
      </tr>
      <tr>
        <td>33</td>
        <td>33</td>
        <td>Jonas Alexander</td>
        <td>Developer</td>
        <td>San Francisco</td>
        <td>2010/07/14</td>
        <td>$86,500</td>
      </tr>
      <tr>
        <td>43</td>
        <td>43</td>
        <td>Shad Decker</td>
        <td>Regional Director</td>
        <td>Edinburgh</td>
        <td>2008/11/13</td>
        <td>$183,000</td>
      </tr>
      <tr>
        <td>16</td>
        <td>16</td>
        <td>Michael Bruce</td>
        <td>Javascript Developer</td>
        <td>Singapore</td>
        <td>2011/06/27</td>
        <td>$183,000</td>
      </tr>
      <tr>
        <td>19</td>
        <td>19</td>
        <td>Donna Snider</td>
        <td>Customer Support</td>
        <td>New York</td>
        <td>2011/01/25</td>
        <td>$112,000</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <th>Seq.</th>
        <th>#</th>
        <th>Name</th>
        <th>Position</th>
        <th>Office</th>
        <th>Start date</th>
        <th>Salary</th>
      </tr>
    </tfoot>
  </table>

  <br>
  <button type="button" class="btn btn-info" data-toggle="modal"
  data-target="#studentDetails">
  {{ "STUDENTS_DETAILS" | translate | titlecase }}</button>

</div>

<!-- Modal DisableServiceData-->
<div class="modal fade" id="studentDetails" tabindex="-1" aria-labelledby="studentDetails" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered student-detail-modal">
      <form class="modal-content col-md-12">
          <div class="row">
              <!-- <div class="col-sm-1">
                  <button (click)="exportDate()" class="btn" style="height:auto"><span
                          style="font-size: 2em; color: green;"><i
                              class="fas fa-file-excel fa-sm"></i></span></button>
              </div> -->
          </div>
          <div class="modal-header">
              <h5 class="modal-title" id="DisableServiceDataLabel">{{ "REPORT" | translate | titlecase }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="card-body">
              <app-test-report #testReport></app-test-report>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ "CLOSE" | translate | titlecase
                  }}</button>
              <button type="button" class="btn btn-secondary" (click)="exportReportToPdf()">{{ "PDF_EXPORT" | translate | titlecase
                  }}</button>
          </div>
      </form>
  </div>
</div>